import Backbone from 'backbone'
import messages from '../messages'
import user from '../user'
import Request from '../helpers/request'

const TestModel = Backbone.Model.extend({
    defaults: {
        questions: [],
        score: 0,
        count: 0,
        fluency_score: 0,
        fluency_count: 0,
        reasoning_score: 0,
        reasoning_count: 0,
        problem_score: 0,
        problem_count: 0,
        accuracy: '',
        star: 0,
        start_timestamp: null,
        end_timestamp: null,
    },
    initialize() {
        // if the score or count changes work out the new accuracy
        this.listenTo(this, 'change', this.accuracy)
    },
    currentQuestion() {
        return this.get('questions')[this.get('count')]
    },
    correct() {
        this.set({
            score: this.get('score') + 1,
            count: this.get('count') + 1,
        })
    },
    incorrect() {
        this.set({
            count: this.get('count') + 1,
        })
    },
    accuracy() {
        if (this.get('count') !== 0) {
            const percentage = Math.round((this.get('score') / this.get('count')) * 100)
            this.set('accuracy', percentage + '%')
        }
    },
    awardStar() {
        if (this.get('accuracy') === '100%') {
            this.set('star', 1)
        }
    },
    reset() {
        this.set(this.defaults)
    },
    sendEmail(to, subject, html) {
        const count = user.get('email_limit').get('count')
        const allowed = user.get('email_limit').allowed()

        if (user.get('uid') === null) {
            return new Promise((resolve, reject) => reject(messages.MSG_RESULTS_NOT_SENT))
        }

        if (allowed) {
            return Request({
                url: '/api/email',
                method: 'POST',
                data: {
                    to: to,
                    subject: subject,
                    html: html
                },
            })
                .then((response) => new Promise((resolve) => {
                    user.get('email_limit').set('count', count + 1)
                    resolve(response)
                }))
        } else {
            return new Promise((resolve, reject) => reject(messages.MSG_EMAIL_LIMIT))
        }
    }
})

export default TestModel
